import { createSelector } from 'reselect';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType, StepOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenario, getScenarioContent } from 'entities/scenario';

export const selectBankAccountOpened = createSelector(getScenarioContent, (content) => {
  return (content as ContentOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>)?.introBlock || {};
});

export const selectSmsCodeIssueInfoModal = createSelector(getScenario, (content) => {
  return (content as StepOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>).interactions.smsCodeIssueInfo.action.modalContent;
});
